module.exports = __webpack_public_path__ + "static/background_video-66c1222f089f17dc8ef024a3924337e4.mp4";